import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React, {useRef, useState} from 'react';
import {formatTime, isFileVideo} from '../helper';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {addingImage, clearAllData} from '../../../../store/redux/imageCropping';
import {IChatReplyState, IImageFileUpload} from '../type';
import {RootState} from '../../../../store/redux';

interface ImageVideoPreviewProps {
  imageFile?: IImageFileUpload;
  file?: File;
  replyingChat?: IChatReplyState | undefined;
  setDropDownIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setImageFile: React.Dispatch<
    React.SetStateAction<IImageFileUpload | undefined>
  >;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
}
const ImageVideoPreview = ({
  imageFile,
  replyingChat,
  file,
  setFile,
  setDropDownIsOpen,
  setImageFile,
}: ImageVideoPreviewProps) => {
  const {cropedImage} = useSelector((state: RootState) => state.imageCropedit);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {guid} = useParams();
  const vidoPlayer = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const playingHandler = () => {
    if (vidoPlayer.current) {
      if (isPlaying) {
        vidoPlayer.current.pause();
      } else {
        vidoPlayer.current.play();
      }
    }
  };

  return (
    <div
      className={classNames(' z-[100] 	 fixed top-0 left-0  right-0', {
        'w-full h-[calc(100%-70px)]': !replyingChat,
        'w-full h-[calc(100%-125px)]': replyingChat,
      })}
    >
      <div className="flex w-full h-full relative bg-white">
        <div className="flex items-center justify-between w-full absolute top-[10px] px-2 gap-2">
          {(imageFile || cropedImage) && (
            <button
              className="flex z-[150] items-center justify-center w-[40px] h-[40px] bg-slate-950 opacity-60 hover:opacity-100	rounded-full text-white"
              onClick={() => {
                dispatch(
                  addingImage({
                    imageFile: cropedImage
                      ? cropedImage
                      : imageFile
                      ? imageFile.imageFile
                      : null,
                  }),
                );
                navigate(`/chat-form/${guid}/add-picture`);
              }}
            >
              <SpanIcon className="icon-namecrop" />
            </button>
          )}
          {file && file.type === 'video/mp4' && (
            <div className="h-[24px] flex items-center justify-center text-xs rounded-[30px] p-2 bg-slate-950 opacity-60 text-white">
              {vidoPlayer.current?.duration
                ? formatTime(Math.trunc(vidoPlayer.current?.duration))
                : '00:00'}
            </div>
          )}
          <button
            className="flex items-center z-[150] justify-center w-[40px] h-[40px] bg-slate-950 opacity-60 hover:opacity-100 rounded-full text-white"
            onClick={() => {
              setImageFile(undefined);
              setFile(undefined);
              setDropDownIsOpen(false);
              dispatch(clearAllData());
            }}
          >
            <SpanIcon className="icon-nameClose-remove" />
          </button>
        </div>
        {file && isFileVideo(file) && !imageFile && (
          <>
            <div className="flex w-full h-full absolute top-0 right-0 left-0 bottom-0  justify-center items-center">
              <button
                type="button"
                className=" w-[40px] justify-center items-center z-60 h-[40px] z-[100] bg-slate-950 opacity-60 hover:opacity-100 rounded-full text-white "
                onClick={() => playingHandler()}
              >
                <SpanIcon
                  className={classNames('p-0 m-0', {
                    'icon-namePlay-Right1': !isPlaying,
                    'icon-namepause1': isPlaying,
                  })}
                />
              </button>
            </div>
            <video
              onPlaying={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
              ref={vidoPlayer}
              className="block m-0 bg-cover"
              width="100%"
              height="100vh"
            >
              Your browser does not support the video tag.
              <source src={URL.createObjectURL(file)} type="video/mp4" />
            </video>
          </>
        )}
        {(imageFile || cropedImage) && !file && (
          <img
            className="w-full h-full object-fill "
            alt={`logo-uploaded`}
            src={
              cropedImage
                ? URL.createObjectURL(cropedImage)
                : imageFile
                ? URL.createObjectURL(imageFile.imageFile)
                : ''
            }
          />
        )}
      </div>
    </div>
  );
};

export default ImageVideoPreview;
